






import { Vue, Component, Prop } from "vue-property-decorator";

// Types
import { IWebhook } from "@/models/webhooks";

@Component({
  components: {
    "webhook-provider": () =>
      import("@/components/app/admin/settings/webhooks/webhookProvider.vue"),
    "webhook-edit-form": () =>
      import("@/components/app/admin/settings/webhooks/webhookEditForm.vue")
  }
})
export default class WebhookEditView extends Vue {
  // Props

  @Prop({ default: null })
  public webhookId!: IWebhook["id"];
}
